import { isElementNode, isTextNode } from 'anodum';

const isEmptyNode = (node) =>
  isTextNode(node) && node.nodeValue.length > 0 && node.nodeValue.trim().length === 0;

const findDeepestNode = (element) => {
  let currentNode = element;

  while (currentNode.lastChild) {
    currentNode = currentNode.lastChild;

    if (isEmptyNode(currentNode)) {
      if (currentNode.previousSibling && !isEmptyNode(currentNode.previousSibling)) {
        currentNode = currentNode.previousSibling;
      }
    }
  }

  return currentNode;
};

const insertBreakIntoEmptyEditableElement = (element) => {
  const deepestChild = findDeepestNode(element);
  const { ownerDocument: liveDocument } = element;
  const { parentNode } = deepestChild;

  const breakElement = liveDocument.createElement('br');

  if (isElementNode(deepestChild)) {
    deepestChild.appendChild(breakElement);
    return;
  }

  parentNode.insertAdjacentElement('beforeend', breakElement);
};

export default insertBreakIntoEmptyEditableElement;
